import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Colors, FlexBox, Skeleton, useIsMobile } from '@brg/ui';
import { useDispatch, useSelector } from 'react-redux';
import { STATUSES, STATUSES_NEW } from '../../const';
import { CompetitionsSelector } from 'shared/reducers/Competitions';
import {
  CompetitionContainer,
  CompetitionDescriptionWrapper,
  CompetitionLogo, CompetitionShowMoreContent,
  InterLogo,
  SelectWrapper
} from './styled';
import { getEnumOptions } from './helpers/competitionUtils';
import './styles.css';
import { CompetitionDropdown } from '_competition/components/CompetitionDropdown';
import { SlideNavigation } from 'shared/components/slideNavigation';
import { COMPETITION_ADMIN_TABS, COMPETITION_VIEW_TABS } from 'shared/pages/exploreHseContextsOldDeprecated/const/tabs';
import useQueryState from 'shared/hooks/useQueryState';
import { HseContextActions } from "../../../shared/reducers/hseCurrentContext";
import { BottomGroupWrapper } from 'shared/pages/explore/styles';
import { ThemeProvider, createGlobalStyle, useTheme } from "styled-components";
import { createThemeByColor } from "../../../shared/helpers/coloring";
import { CustomBgWrapper } from "../../../shared/components/CustomBgWrapper/CustomBgWrapper";
import { DropdownTabs } from 'shared/pages/exploreHseContextsNew/components/DropdownTabs';
import { AppTester } from "../../../supporting";
import { COMPETITIONS_CONTEXTS, getMediiiaCompetitionContext } from './const/competitionContexts';
import ProjectsButchControllerUltimate from 'core/controllers/ProjectsButchControllerUltimate';
import { ProjectsGridActions } from 'shared/reducers/ProjectsGridSlice';
import useCompetitionTabs from './hooks/useCompetitionsTabs';
import { CompetitionTagsCloud } from "./competitionTagsCloud";
import { COMPETITIONS_ADD_TABS } from './const/competitionAddTabs';
import { getPathContext } from 'core/helpers/getPathContext';
import { useShowcaseTexts } from './hooks/useShowcaseTexts';
import { slashPathIndex } from 'shared/constants/enginePaths';
import { CoreContainer } from 'core';

export const MobileNavGlobalStyle = createGlobalStyle`

  .target-icon-wrapper {
    div {
      color: #fefefe !important;
    }
  }

  .competition-nav-wrapper, .competition-sort-wrapper .dropdown-element-popup {
    background: #343434;

    .dropdown-list-item {
      font-size: 15px;
      line-height: 20px;
      font-weight: 600;
      color: #c5c6c7;
      background: #343434 !important;

      div {
        color: #c5c6c7 !important;
      }

      * {
        font-weight: 600 !important;
      }

      .active {
        color: #fefefe !important;
      }

      svg path {
        fill: ${Colors.galBlack61} !important;
      }

      .active ~ svg path {
        fill: #fefefe !important;
      }

      &:hover {
        background: #2c2c2b;
      }
    }

    .dropdown-list-item:hover {
      background: #2c2c2b !important;
    }
  }
`;

const removeMediiia = (str: string) => {
  return str.replace(/mediiia/gi, '');
}

interface OptionProps {
  name: string
  identifier: number
}

export interface RefreshListProps {
  pageNumber: number
  i18n: any
  selectedStatus?: OptionProps
  dispatch: any;
  contexts: string[];
  isBriefCompetition?: boolean;
}

export const AllCompetitionsPage = () => {
  const { t, i18n: { language } } = useTranslation();
  const isMobile = useIsMobile();

  const statusesOptions = useMemo(() => getEnumOptions(STATUSES_NEW, t), [t]);
  const [winnersSorting, setWinnersSorting] = useState(1);
  const dispatch = useDispatch();
  const { isLoading } = useSelector(CompetitionsSelector);
  const theme1 = useTheme();
  const { theme } = createThemeByColor(theme1.competition.bg, theme1);
  const isHse = AppTester.isHSEDesign() || AppTester.isSchool();
  const isAcademy = AppTester.isAcademy();
  const isCGRave = AppTester.isCGRAVE();
  const isExams = AppTester.isExamHSE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isGreenAward = AppTester.isGreenAward();
  const isBooksGallllery = AppTester.isBooksGallllery();
  const isMediiia = AppTester.isMediiia();
  const isGeograffee = AppTester.isGeograffee();
  const isPortfolio365 = AppTester.isPortfolio365();
  const isKiiidsArt = AppTester.isKiiidsArt()
  const isCompetition = AppTester.isCompetition();
  const isUrbanAwards = AppTester.isMediiiaUrban()
  const isArtMediiia = AppTester.isArtMediiia()
  const isHseCreative = AppTester.isCreativeHSE()
  const isBrnd = AppTester.isBrnd()
  const isGame = AppTester.isGameDeziiign();
  const isLabDeziiign = AppTester.isLabDeziiign();
  const isFashionDeziiign = AppTester.isFashionDeziiign();
  const isHseSpace = AppTester.isHseSpace();
  const isHSESpaceSegmants = AppTester.isHSESpaceSegmants();
  const isGeoDafes = AppTester.isGeoDafes();
  const { tabsFormatted, commonFilter } = useCompetitionTabs();
  const isMediiiaPhoto = AppTester.isMediiiaPhoto() 
  const isBooksMediiia = AppTester.isBooksMediiia() 
  const isMediiiaCine = AppTester.isMediiiaCine() 
  const isMediiiaAi = AppTester.isMediiiaAi() 
  const isHistoryMediiia = AppTester.isHistoryMediiia() 
  const isMediiiaStories = AppTester.isMediiiaStories() 
  const isMusicMediiia = AppTester.isMusicMediiia() 
  const isMediiiaSport = AppTester.isMediiiaSport()
  const isMediiiaFood = AppTester.isMediiiaFood() 
  const isMediiiaProf = AppTester.isMediiiaProf() 
  const isMediiiaNature = AppTester.isMediiiaNature() 
  const isLectureMediiia = AppTester.isLectureMediiia() 
  const isMediiiaConcept = AppTester.isMediiiaConcept() 
  const isMediiiaAuto = AppTester.isMediiiaAuto() 
  const isEvent = AppTester.isContext('eventmediiia');

  const isMediiiaContextWithTabs = isArtMediiia || isMediiiaPhoto || isBooksMediiia || isMediiiaCine || isMediiiaAi || isHistoryMediiia || isMediiiaStories || isMediiiaAuto ||
  isMusicMediiia || isMediiiaFood || isMediiiaProf || isMediiiaNature || isLectureMediiia || isMediiiaConcept || isMediiiaSport || isEvent

  const { application, mode: env } = getPathContext();

  const { has: isMediaContext, name: mediaContextName } = useMemo(() => {
    const has = !!Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application);
    const splittedCtx = Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application)?.split('/')?.[1];
    let name = ''
    if (!!splittedCtx) {
      name = removeMediiia(splittedCtx);
    }
    return { has, name }
  }, [application]);

  const navItems = useMemo(() => {
    if (isPortfolio365 || isKiiidsArt || isBrnd || (isMediaContext && !isUrbanAwards && !isMediiiaContextWithTabs) || (isLectureMediiia && !isMediiiaContextWithTabs)) return {};
    return {
      ...tabsFormatted?.map((i) => i?.name)
        ?.filter((i) => i !== COMPETITIONS_CONTEXTS.briefs)
        ?.reduce((a, v) => {
          const key = isLabDeziiign && v === COMPETITIONS_CONTEXTS.concept ? 'allDeziiignCompetitions' :
            (isFashionDeziiign || isUrbanAwards || isGame) && v === COMPETITIONS_CONTEXTS.concept ? 'fashion_concept' :
              isHSESpaceSegmants && v === COMPETITIONS_CONTEXTS.hsespace_awards ? 'space_concept' :
                v
          return { ...a, [v]: t(`tab_names.competition_tabs.${key}`).toLowerCase() }
        }, {})
    }
  }, [isPortfolio365, isKiiidsArt, isUrbanAwards, tabsFormatted, isBrnd, isMediaContext, t])

  const getMediiiaContextFromAppTester = () => {
    if (isMediiiaPhoto) return COMPETITIONS_CONTEXTS.photomediiiawards;
    if (isBooksMediiia) return COMPETITIONS_CONTEXTS.booksmediiiawards;
    if (isMediiiaCine) return COMPETITIONS_CONTEXTS.cinemediiiawards;
    if (isMediiiaAi) return COMPETITIONS_CONTEXTS.aimediiiawards;
    if (isHistoryMediiia) return COMPETITIONS_CONTEXTS.historymediiiawards;   
    if (isMediiiaStories) return COMPETITIONS_CONTEXTS.storiesmediiiawards;
    if (isMediiiaAuto) return COMPETITIONS_CONTEXTS.automediiiawards;
    if (isMusicMediiia) return COMPETITIONS_CONTEXTS.musicmediiiawards;
    if (isMediiiaFood) return COMPETITIONS_CONTEXTS.foodmediiiawards;
    if (isMediiiaProf) return COMPETITIONS_CONTEXTS.profmediiiawards;
    if (isMediiiaNature) return COMPETITIONS_CONTEXTS.naturemediiiawards;
    if (isMediiiaConcept) return COMPETITIONS_CONTEXTS.conceptmediiiawards;
    if (isArtMediiia) return COMPETITIONS_CONTEXTS.artmediiiawards;
    if (isEvent) return COMPETITIONS_CONTEXTS.eventmediiiawards;
    return null;
  };

  const initialTab = useMemo(() => (
    isMediaContext && mediaContextName && !isUrbanAwards ? getMediiiaCompetitionContext(mediaContextName) :
      isLabDeziiign ? COMPETITIONS_CONTEXTS.ldAwards :
        isLectureMediiia ? COMPETITIONS_CONTEXTS.educationmediiiawards :
          isGame ? COMPETITIONS_CONTEXTS.gdawards :
            isFashionDeziiign ? COMPETITIONS_CONTEXTS.fdawards :
              isUrbanAwards ? COMPETITIONS_CONTEXTS.udawards :
                getMediiiaContextFromAppTester() ||
                isHseCreative ? COMPETITIONS_CONTEXTS.hsecreativeawards :
                  isMediiiaSport ? COMPETITIONS_CONTEXTS.sportmediiiawards :
                    isGreenAward ? COMPETITIONS_CONTEXTS.greenaward :
                      isGreenAward ? COMPETITIONS_CONTEXTS.lastgreenaward :
                        isBooksGallllery ? COMPETITIONS_CONTEXTS.booksmediiiawards :
                          isAdcrDafesNet ? COMPETITIONS_CONTEXTS.adcrawards :
                            isBrnd ? COMPETITIONS_CONTEXTS.brndawards :
                              isMediiia ? COMPETITIONS_CONTEXTS.mediiiaawards :
                                isHSESpaceSegmants ? tabsFormatted[0]?.name :
                                  isHseSpace && !isHSESpaceSegmants ? COMPETITIONS_CONTEXTS.hsespace_awards :
                                    isHse ? COMPETITION_VIEW_TABS.competitions :
                                      isAcademy ? Object.keys(navItems)?.find((item, idx) => item === 'citycompetitions') :
                                        isCompetition ? Object.keys(navItems)?.find((item, idx) => item === 'concept')
                                          : Object.keys(navItems)?.find((item, idx) => idx === 0))
    , [isHseCreative, isMediiiaSport, mediaContextName, isHSESpaceSegmants, isHseSpace, isGame, isFashionDeziiign, isUrbanAwards, language, isMediiia, isMediaContext, isHse, isAcademy, navItems, isCompetition, isGreenAward, isAdcrDafesNet, isBrnd, isArtMediiia])

  const [{ tab: currentTab = initialTab, sorting, tagId }, setQueryParams] = useQueryState();

  const { title, description } = useShowcaseTexts(currentTab);

  const currentSorting = useMemo(() =>
   ((isGreenAward && currentTab === COMPETITIONS_CONTEXTS.lastgreenaward))
      ? STATUSES_NEW.Completed
      : currentTab === 'winners'
        ? winnersSorting
        : currentTab === 'ratings'
          ? (statusesOptions.find(i => i.identifier === Number(sorting))?.identifier || STATUSES_NEW.Completed)
          : (statusesOptions.find(i => i.identifier === Number(sorting))?.identifier || STATUSES_NEW.Open)
    , [isGreenAward, currentTab, winnersSorting, isKiiidsArt, statusesOptions, sorting]);

  const sortingRef = useRef(sorting);

  useEffect(() => {
    sortingRef.current = currentSorting;
  }, [currentSorting])

  const requiredParams = useMemo(() => ({ tagId }), [tagId])

  const onChangeStatus = useCallback((newStatus: OptionProps | any) => {
    setQueryParams({ sorting: newStatus?.identifier, tab: currentTab, tagId: null })
  }, [currentTab])

  const onTabChange = (tab: string) => {
    const defaultSorting = tab === 'ratings' ? STATUSES_NEW.Completed : sortingRef.current;
    setQueryParams({ page: 1, tab, tagId: undefined, sorting: defaultSorting }, { replace: true });
  }

  useEffect(() => {
    dispatch(HseContextActions.set({
      tabs: COMPETITION_VIEW_TABS,
      initialTab: COMPETITION_VIEW_TABS.competitions,
      onSetTab: onTabChange
    }))
    return () => {
      dispatch(HseContextActions.reset({}));
    }
  }, [dispatch, onTabChange])

  useEffect(() => {
    if (tabsFormatted?.length) {
      dispatch(ProjectsGridActions.setTabs({
        tabs: tabsFormatted,
        categories: [],
        mainFilter: commonFilter,
        context: 'competition-list',
      }))
    }
  }, [tabsFormatted, commonFilter, dispatch])

  useEffect(() => {
    if (!sorting && (currentTab === COMPETITION_ADMIN_TABS.ratings || isPortfolio365 || currentTab === 'ratings')) {
      setQueryParams({ sorting: STATUSES_NEW.Completed })
    }
  }, [isAcademy, currentTab, sorting])

  const isDarkTheme = useMemo(() => theme.competition.bg === '#343434', [theme])

  const activeTab = useMemo(
    () => {
      return isHseCreative && currentTab === 'competitions' ? 'hsecreativeawards' :
        isHse && !isHseSpace && !isExams && currentTab === 'competitions' ?
          COMPETITIONS_CONTEXTS.main_hse :
          isExams ? COMPETITIONS_CONTEXTS.exams :
          isPortfolio365 ? 'main_portfolio' :
            isKiiidsArt ? COMPETITIONS_CONTEXTS.kiiids_awards :
              currentTab
    }, [isHse, currentTab, isHseCreative, isPortfolio365, isExams, isKiiidsArt]);

  useEffect(() => {
    if (activeTab === COMPETITIONS_CONTEXTS.main_hse) {
      onTabChange(COMPETITIONS_CONTEXTS.main_hse)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.citycompetitions) {
      onTabChange(COMPETITIONS_CONTEXTS.citycompetitions)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.concept) {
      onTabChange(COMPETITIONS_CONTEXTS.concept)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.mediiiaawards) {
      onTabChange(COMPETITIONS_CONTEXTS.mediiiaawards)
    }
  }, [])

  const hasTabsItems = useMemo(() => {
    return Object.keys(navItems)?.length > 0
  } , [navItems])

  const MobileDropdownTabs = useMemo(() => {
    if (!hasTabsItems) return;
    return (
      <>
        <MobileNavGlobalStyle />
        <DropdownTabs
          customTitleTheme={theme as any}
          whiteTheme={false}
          activeTabKey={activeTab}
          mobileShrink
          isShort={true}
          items={navItems}
          onChange={onTabChange}
        />
      </>
    )
  }, [onTabChange, hasTabsItems, navItems, theme, activeTab, currentTab]);

  const ShowMore = (props: any) => (
    <CompetitionShowMoreContent
      {...props}
    >
      {props.children}
    </CompetitionShowMoreContent>
  )

  const sortFilter = useMemo(() => ({
    sort: Number(sorting) === 5 ? 2 : 1,
    limit: 20,
  }), [sorting]);

  const competitionStatus = useMemo(
    () =>{

      if (isGreenAward) {
        return undefined
      }
      return (Number(sorting) === 1 || !sorting || activeTab === 'winners') ? [STATUSES.Open, STATUSES.Summarizing, STATUSES.Voting] : [STATUSES.Completed, STATUSES.Archived]
    } , [isGreenAward, sorting, activeTab])

  const tagFilter = useMemo(() => {
    if (tabsFormatted?.length) {
      const tab = tabsFormatted.find(({ name }) => name === activeTab)
      return {
        ...tab?.filter,
        competitionStatus,
      }
    }
  }, [activeTab, tabsFormatted, competitionStatus])

  const content = useMemo(() => {
    if (![
      COMPETITION_VIEW_TABS.winners,
      COMPETITIONS_ADD_TABS.jury,
      COMPETITIONS_ADD_TABS.figurine,
      COMPETITIONS_ADD_TABS.rules
    ]?.includes(currentTab)) {
      return (
        <ProjectsButchControllerUltimate
          filter={{
            ...sortFilter,
            contexts: commonFilter.contexts,
            ...(tagId && { byTagIds: [tagId] }),
            competitionStatus,
          }}
          loading={false}
          currentCategory='main'
          currentTab={activeTab}
          contextName='competition-list'
          isMainPage
          scrollStyles={{ overflowX: 'hidden' }}
          isCompetitions
        />
      )
    }
  }, [sortFilter, activeTab, currentTab, isCGRave, commonFilter.contexts, tagId])

  return (
    <ThemeProvider theme={theme as any}>
      <CustomBgWrapper backgroundColor={theme1.competition.bg}>
        <CoreContainer>
          <>
            <FlexBox justify={'flex-start'} justifyMobile='left' offsetTop={0} offsetTopMobile={"0px"}>
              {isAcademy ? (
                <InterLogo>
                  {title}
                </InterLogo>
              ) : (
                <CompetitionLogo smallOffset={isCGRave} isAlumni={!isHse} isHSEDesign={isHse}>
                  {title}
                </CompetitionLogo>
              )}
            </FlexBox>
            <BottomGroupWrapper disableOffset={isCGRave} isCGRave={isCGRave}>
              <FlexBox widthMobile={"100%"} style={{ whiteSpace: 'pre-wrap' }}>
                <CompetitionDescriptionWrapper>
                  <ShowMore
                    importantStyles
                    more={t('show_more_text')}
                    less={t('show_less_text')}
                    lines={4}
                  >
                    {isGreenAward ? (
                      <span dangerouslySetInnerHTML={{ __html: description }} />
                    ) : (
                      description
                    )}
                  </ShowMore>
                </CompetitionDescriptionWrapper>
              </FlexBox>
            </BottomGroupWrapper>
          </>
          {<FlexBox offsetTop={24} direction='column' directionMobile='column' justify='space-between'>
            <FlexBox 
              width={'100%'} 
              align="center" 
              direction='row' 
              directionMobile='row' 
              justify='space-between'
              justifyMobile={hasTabsItems ? 'space-between' : 'flex-end'} style={{ position: 'relative' }}>
              {!isGreenAward && !isExams ?  (
                !isMobile ? (
                  <SlideNavigation
                    activeIndexKey={activeTab}
                    onChange={onTabChange}
                    items={navItems}
                    isDropdown
                    autoWidth
                    isLoading={isLoading}
                    whiteTheme={false}
                    isCompetition={true}
                  />
                ) : (
                  MobileDropdownTabs
                )
              ) : null}

              <SelectWrapper
                direction="row"
                width={'100%'}
                widthMobile={'auto'}
                gx={5}
                justify={'flex-end'}
                justifyMobile={"flex-end"}
                directionMobile="row"
                align='flex-end'
                alignMobile='center'
                themeType={isGeograffee ? 'grey' : isCGRave ? 'black' : 'white'}
                isGeograffee={isGeograffee}
              >
                {
                  !isGreenAward &&
                  (
                    <CompetitionDropdown
                      selectedSorting={currentSorting}
                      onSortingChange={onChangeStatus}
                      sortingMethods={statusesOptions}
                      isDarkTheme={isDarkTheme}
                    />
                  )
                }
              </SelectWrapper>
            </FlexBox>
          </FlexBox>}
          {tagFilter && !isGreenAward && (
            <CompetitionTagsCloud filter={tagFilter} />
          )}
          {isLoading && currentTab !== COMPETITION_VIEW_TABS.winners && (
            <CompetitionContainer>
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
            </CompetitionContainer>
          )}
          {content}
        </CoreContainer>
      </CustomBgWrapper>
    </ThemeProvider>
  );
};
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Colors, FlexBox, Skeleton, useIsMobile } from '@brg/ui';
import { useDispatch, useSelector } from 'react-redux';
import { STATUSES, STATUSES_NEW } from '../../const';
import { CompetitionsSelector } from 'shared/reducers/Competitions';
import {
  CompetitionContainer,
  CompetitionDescriptionWrapper,
  CompetitionLogo, CompetitionShowMoreContent,
  InterLogo,
  SelectWrapper
} from './styled';
import { getEnumOptions } from './helpers/competitionUtils';
import './styles.css';
import { CompetitionDropdown } from '_competition/components/CompetitionDropdown';
import { SlideNavigation } from 'shared/components/slideNavigation';
import { COMPETITION_ADMIN_TABS, COMPETITION_VIEW_TABS } from 'shared/pages/exploreHseContextsOldDeprecated/const/tabs';
import useQueryState from 'shared/hooks/useQueryState';
import { HseContextActions } from "../../../shared/reducers/hseCurrentContext";
import { BottomGroupWrapper } from 'shared/pages/explore/styles';
import { ThemeProvider, createGlobalStyle, useTheme } from "styled-components";
import { createThemeByColor } from "../../../shared/helpers/coloring";
import { CustomBgWrapper } from "../../../shared/components/CustomBgWrapper/CustomBgWrapper";
import { DropdownTabs } from 'shared/pages/exploreHseContextsNew/components/DropdownTabs';
import { AppTester } from "../../../supporting";
import { COMPETITIONS_CONTEXTS, getMediiiaCompetitionContext } from './const/competitionContexts';
import ProjectsButchControllerUltimate from 'core/controllers/ProjectsButchControllerUltimate';
import { ProjectsGridActions } from 'shared/reducers/ProjectsGridSlice';
import useCompetitionTabs from './hooks/useCompetitionsTabs';
import { CompetitionTagsCloud } from "./competitionTagsCloud";
import { COMPETITIONS_ADD_TABS } from './const/competitionAddTabs';
import { getPathContext } from 'core/helpers/getPathContext';
import { useShowcaseTexts } from './hooks/useShowcaseTexts';
import { slashPathIndex } from 'shared/constants/enginePaths';
import { CoreContainer } from 'core';

export const MobileNavGlobalStyle = createGlobalStyle`

  .target-icon-wrapper {
    div {
      color: #fefefe !important;
    }
  }

  .competition-nav-wrapper, .competition-sort-wrapper .dropdown-element-popup {
    background: #343434;

    .dropdown-list-item {
      font-size: 15px;
      line-height: 20px;
      font-weight: 600;
      color: #c5c6c7;
      background: #343434 !important;

      div {
        color: #c5c6c7 !important;
      }

      * {
        font-weight: 600 !important;
      }

      .active {
        color: #fefefe !important;
      }

      svg path {
        fill: ${Colors.galBlack61} !important;
      }

      .active ~ svg path {
        fill: #fefefe !important;
      }

      &:hover {
        background: #2c2c2b;
      }
    }

    .dropdown-list-item:hover {
      background: #2c2c2b !important;
    }
  }
`;

const removeMediiia = (str: string) => {
  return str.replace(/mediiia/gi, '');
}

interface OptionProps {
  name: string
  identifier: number
}

export interface RefreshListProps {
  pageNumber: number
  i18n: any
  selectedStatus?: OptionProps
  dispatch: any;
  contexts: string[];
  isBriefCompetition?: boolean;
}

export const AllCompetitionsPage = () => {
  const { t, i18n: { language } } = useTranslation();
  const isMobile = useIsMobile();

  const statusesOptions = useMemo(() => getEnumOptions(STATUSES_NEW, t), [t]);
  const [winnersSorting, setWinnersSorting] = useState(1);
  const dispatch = useDispatch();
  const { isLoading } = useSelector(CompetitionsSelector);
  const theme1 = useTheme();
  const { theme } = createThemeByColor(theme1.competition.bg, theme1);
  const isHse = AppTester.isHSEDesign() || AppTester.isSchool();
  const isAcademy = AppTester.isAcademy();
  const isCGRave = AppTester.isCGRAVE();
  const isExams = AppTester.isExamHSE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isGreenAward = AppTester.isGreenAward();
  const isBooksGallllery = AppTester.isBooksGallllery();
  const isMediiia = AppTester.isMediiia();
  const isGeograffee = AppTester.isGeograffee();
  const isPortfolio365 = AppTester.isPortfolio365();
  const isKiiidsArt = AppTester.isKiiidsArt()
  const isCompetition = AppTester.isCompetition();
  const isUrbanAwards = AppTester.isMediiiaUrban()
  const isArtMediiia = AppTester.isArtMediiia()
  const isHseCreative = AppTester.isCreativeHSE()
  const isBrnd = AppTester.isBrnd()
  const isGame = AppTester.isGameDeziiign();
  const isLabDeziiign = AppTester.isLabDeziiign();
  const isFashionDeziiign = AppTester.isFashionDeziiign();
  const isHseSpace = AppTester.isHseSpace();
  const isHSESpaceSegmants = AppTester.isHSESpaceSegmants();
  const isGeoDafes = AppTester.isGeoDafes();
  const { tabsFormatted, commonFilter } = useCompetitionTabs();
  const isMediiiaPhoto = AppTester.isMediiiaPhoto() 
  const isBooksMediiia = AppTester.isBooksMediiia() 
  const isMediiiaCine = AppTester.isMediiiaCine() 
  const isMediiiaAi = AppTester.isMediiiaAi() 
  const isHistoryMediiia = AppTester.isHistoryMediiia() 
  const isMediiiaStories = AppTester.isMediiiaStories() 
  const isMusicMediiia = AppTester.isMusicMediiia() 
  const isMediiiaSport = AppTester.isMediiiaSport()
  const isMediiiaFood = AppTester.isMediiiaFood() 
  const isMediiiaProf = AppTester.isMediiiaProf() 
  const isMediiiaNature = AppTester.isMediiiaNature() 
  const isLectureMediiia = AppTester.isLectureMediiia() 
  const isMediiiaConcept = AppTester.isMediiiaConcept() 
  const isMediiiaAuto = AppTester.isMediiiaAuto() 
  const isEvent = AppTester.isContext('eventmediiia');

  const isMediiiaContextWithTabs = isArtMediiia || isMediiiaPhoto || isBooksMediiia || isMediiiaCine || isMediiiaAi || isHistoryMediiia || isMediiiaStories || isMediiiaAuto ||
  isMusicMediiia || isMediiiaFood || isMediiiaProf || isMediiiaNature || isLectureMediiia || isMediiiaConcept || isMediiiaSport || isEvent

  const { application, mode: env } = getPathContext();

  const { has: isMediaContext, name: mediaContextName } = useMemo(() => {
    const has = !!Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application);
    const splittedCtx = Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application)?.split('/')?.[1];
    let name = ''
    if (!!splittedCtx) {
      name = removeMediiia(splittedCtx);
    }
    return { has, name }
  }, [application]);

  const navItems = useMemo(() => {
    if (isPortfolio365 || isKiiidsArt || isBrnd || (isMediaContext && !isUrbanAwards && !isMediiiaContextWithTabs) || (isLectureMediiia && !isMediiiaContextWithTabs)) return {};
    return {
      ...tabsFormatted?.map((i) => i?.name)
        ?.filter((i) => i !== COMPETITIONS_CONTEXTS.briefs)
        ?.reduce((a, v) => {
          const key = isLabDeziiign && v === COMPETITIONS_CONTEXTS.concept ? 'allDeziiignCompetitions' :
            (isFashionDeziiign || isUrbanAwards || isGame) && v === COMPETITIONS_CONTEXTS.concept ? 'fashion_concept' :
              isHSESpaceSegmants && v === COMPETITIONS_CONTEXTS.hsespace_awards ? 'space_concept' :
                v
          return { ...a, [v]: t(`tab_names.competition_tabs.${key}`).toLowerCase() }
        }, {})
    }
  }, [isPortfolio365, isKiiidsArt, isUrbanAwards, tabsFormatted, isBrnd, isMediaContext, t])

  const getMediiiaContextFromAppTester = () => {
    if (isMediiiaPhoto) return COMPETITIONS_CONTEXTS.photomediiiawards;
    if (isBooksMediiia) return COMPETITIONS_CONTEXTS.booksmediiiawards;
    if (isMediiiaCine) return COMPETITIONS_CONTEXTS.cinemediiiawards;
    if (isMediiiaAi) return COMPETITIONS_CONTEXTS.aimediiiawards;
    if (isHistoryMediiia) return COMPETITIONS_CONTEXTS.historymediiiawards;   
    if (isMediiiaStories) return COMPETITIONS_CONTEXTS.storiesmediiiawards;
    if (isMediiiaAuto) return COMPETITIONS_CONTEXTS.automediiiawards;
    if (isMusicMediiia) return COMPETITIONS_CONTEXTS.musicmediiiawards;
    if (isMediiiaFood) return COMPETITIONS_CONTEXTS.foodmediiiawards;
    if (isMediiiaProf) return COMPETITIONS_CONTEXTS.profmediiiawards;
    if (isMediiiaNature) return COMPETITIONS_CONTEXTS.naturemediiiawards;
    if (isMediiiaConcept) return COMPETITIONS_CONTEXTS.conceptmediiiawards;
    if (isArtMediiia) return COMPETITIONS_CONTEXTS.artmediiiawards;
    if (isEvent) return COMPETITIONS_CONTEXTS.eventmediiiawards;
    return null;
  };

  const initialTab = useMemo(() => (
    isMediaContext && mediaContextName && !isUrbanAwards ? getMediiiaCompetitionContext(mediaContextName) :
      isLabDeziiign ? COMPETITIONS_CONTEXTS.ldAwards :
        isLectureMediiia ? COMPETITIONS_CONTEXTS.educationmediiiawards :
          isGame ? COMPETITIONS_CONTEXTS.gdawards :
            isFashionDeziiign ? COMPETITIONS_CONTEXTS.fdawards :
              isUrbanAwards ? COMPETITIONS_CONTEXTS.udawards :
                getMediiiaContextFromAppTester() ||
                isHseCreative ? COMPETITIONS_CONTEXTS.hsecreativeawards :
                  isMediiiaSport ? COMPETITIONS_CONTEXTS.sportmediiiawards :
                    isGreenAward ? COMPETITIONS_CONTEXTS.greenaward :
                      isGreenAward ? COMPETITIONS_CONTEXTS.lastgreenaward :
                        isBooksGallllery ? COMPETITIONS_CONTEXTS.booksmediiiawards :
                          isAdcrDafesNet ? COMPETITIONS_CONTEXTS.adcrawards :
                            isBrnd ? COMPETITIONS_CONTEXTS.brndawards :
                              isMediiia ? COMPETITIONS_CONTEXTS.mediiiaawards :
                                isHSESpaceSegmants ? tabsFormatted[0]?.name :
                                  isHseSpace && !isHSESpaceSegmants ? COMPETITIONS_CONTEXTS.hsespace_awards :
                                    isHse ? COMPETITION_VIEW_TABS.competitions :
                                      isAcademy ? Object.keys(navItems)?.find((item, idx) => item === 'citycompetitions') :
                                        isCompetition ? Object.keys(navItems)?.find((item, idx) => item === 'concept')
                                          : Object.keys(navItems)?.find((item, idx) => idx === 0))
    , [isHseCreative, isMediiiaSport, mediaContextName, isHSESpaceSegmants, isHseSpace, isGame, isFashionDeziiign, isUrbanAwards, language, isMediiia, isMediaContext, isHse, isAcademy, navItems, isCompetition, isGreenAward, isAdcrDafesNet, isBrnd, isArtMediiia])

  const [{ tab: currentTab = initialTab, sorting, tagId }, setQueryParams] = useQueryState();

  const { title, description } = useShowcaseTexts(currentTab);

  const currentSorting = useMemo(() =>
   ((isGreenAward && currentTab === COMPETITIONS_CONTEXTS.lastgreenaward))
      ? STATUSES_NEW.Completed
      : currentTab === 'winners'
        ? winnersSorting
        : currentTab === 'ratings'
          ? (statusesOptions.find(i => i.identifier === Number(sorting))?.identifier || STATUSES_NEW.Completed)
          : (statusesOptions.find(i => i.identifier === Number(sorting))?.identifier || STATUSES_NEW.Open)
    , [isGreenAward, currentTab, winnersSorting, isKiiidsArt, statusesOptions, sorting]);

  const sortingRef = useRef(sorting);

  useEffect(() => {
    sortingRef.current = currentSorting;
  }, [currentSorting])

  const requiredParams = useMemo(() => ({ tagId }), [tagId])

  const onChangeStatus = useCallback((newStatus: OptionProps | any) => {
    setQueryParams({ sorting: newStatus?.identifier, tab: currentTab, tagId: null })
  }, [currentTab])

  const onTabChange = (tab: string) => {
    const defaultSorting = tab === 'ratings' ? STATUSES_NEW.Completed : sortingRef.current;
    setQueryParams({ page: 1, tab, tagId: undefined, sorting: defaultSorting }, { replace: true });
  }

  useEffect(() => {
    dispatch(HseContextActions.set({
      tabs: COMPETITION_VIEW_TABS,
      initialTab: COMPETITION_VIEW_TABS.competitions,
      onSetTab: onTabChange
    }))
    return () => {
      dispatch(HseContextActions.reset({}));
    }
  }, [dispatch, onTabChange])

  useEffect(() => {
    if (tabsFormatted?.length) {
      dispatch(ProjectsGridActions.setTabs({
        tabs: tabsFormatted,
        categories: [],
        mainFilter: commonFilter,
        context: 'competition-list',
      }))
    }
  }, [tabsFormatted, commonFilter, dispatch])

  useEffect(() => {
    if (!sorting && (currentTab === COMPETITION_ADMIN_TABS.ratings || isPortfolio365 || currentTab === 'ratings')) {
      setQueryParams({ sorting: STATUSES_NEW.Completed })
    }
  }, [isAcademy, currentTab, sorting])

  const isDarkTheme = useMemo(() => theme.competition.bg === '#343434', [theme])

  const activeTab = useMemo(
    () => {
      return isHseCreative && currentTab === 'competitions' ? 'hsecreativeawards' :
        isHse && !isHseSpace && !isExams && currentTab === 'competitions' ?
          COMPETITIONS_CONTEXTS.main_hse :
          isExams ? COMPETITIONS_CONTEXTS.exams :
          isPortfolio365 ? 'main_portfolio' :
            isKiiidsArt ? COMPETITIONS_CONTEXTS.kiiids_awards :
              currentTab
    }, [isHse, currentTab, isHseCreative, isPortfolio365, isExams, isKiiidsArt]);

  useEffect(() => {
    if (activeTab === COMPETITIONS_CONTEXTS.main_hse) {
      onTabChange(COMPETITIONS_CONTEXTS.main_hse)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.citycompetitions) {
      onTabChange(COMPETITIONS_CONTEXTS.citycompetitions)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.concept) {
      onTabChange(COMPETITIONS_CONTEXTS.concept)
    }
    if (activeTab === COMPETITIONS_CONTEXTS.mediiiaawards) {
      onTabChange(COMPETITIONS_CONTEXTS.mediiiaawards)
    }
  }, [])

  const hasTabsItems = useMemo(() => {
    return Object.keys(navItems)?.length > 0
  } , [navItems])

  const MobileDropdownTabs = useMemo(() => {
    if (!hasTabsItems) return;
    return (
      <>
        <MobileNavGlobalStyle />
        <DropdownTabs
          customTitleTheme={theme as any}
          whiteTheme={false}
          activeTabKey={activeTab}
          mobileShrink
          isShort={true}
          items={navItems}
          onChange={onTabChange}
        />
      </>
    )
  }, [onTabChange, hasTabsItems, navItems, theme, activeTab, currentTab]);

  const ShowMore = (props: any) => (
    <CompetitionShowMoreContent
      {...props}
    >
      {props.children}
    </CompetitionShowMoreContent>
  )

  const sortFilter = useMemo(() => ({
    sort: Number(sorting) === 5 ? 2 : 1,
    limit: 20,
  }), [sorting]);

  const competitionStatus = useMemo(
    () =>{

      if (isGreenAward) {
        return undefined
      }
      return (Number(sorting) === 1 || !sorting || activeTab === 'winners') ? [STATUSES.Open, STATUSES.Summarizing, STATUSES.Voting] : [STATUSES.Completed, STATUSES.Archived]
    } , [isGreenAward, sorting, activeTab])

  const tagFilter = useMemo(() => {
    if (tabsFormatted?.length) {
      const tab = tabsFormatted.find(({ name }) => name === activeTab)
      return {
        ...tab?.filter,
        competitionStatus,
      }
    }
  }, [activeTab, tabsFormatted, competitionStatus])

  const content = useMemo(() => {
    if (![
      COMPETITION_VIEW_TABS.winners,
      COMPETITIONS_ADD_TABS.jury,
      COMPETITIONS_ADD_TABS.figurine,
      COMPETITIONS_ADD_TABS.rules
    ]?.includes(currentTab)) {
      return (
        <ProjectsButchControllerUltimate
          filter={{
            ...sortFilter,
            contexts: commonFilter.contexts,
            ...(tagId && { byTagIds: [tagId] }),
            competitionStatus,
          }}
          loading={false}
          currentCategory='main'
          currentTab={activeTab}
          contextName='competition-list'
          isMainPage
          scrollStyles={{ overflowX: 'hidden' }}
          isCompetitions
        />
      )
    }
  }, [sortFilter, activeTab, currentTab, isCGRave, commonFilter.contexts, tagId])

  return (
    <ThemeProvider theme={theme as any}>
      <CustomBgWrapper backgroundColor={theme1.competition.bg}>
        <CoreContainer>
          <>
            <FlexBox justify={'flex-start'} justifyMobile='left' offsetTop={0} offsetTopMobile={"0px"}>
              {isAcademy ? (
                <InterLogo>
                  {title}
                </InterLogo>
              ) : (
                <CompetitionLogo smallOffset={isCGRave} isAlumni={!isHse} isHSEDesign={isHse}>
                  {title}
                </CompetitionLogo>
              )}
            </FlexBox>
            <BottomGroupWrapper disableOffset={isCGRave} isCGRave={isCGRave}>
              <FlexBox widthMobile={"100%"} style={{ whiteSpace: 'pre-wrap' }}>
                <CompetitionDescriptionWrapper>
                  <ShowMore
                    importantStyles
                    more={t('show_more_text')}
                    less={t('show_less_text')}
                    lines={4}
                  >
                    {isGreenAward ? (
                      <span dangerouslySetInnerHTML={{ __html: description }} />
                    ) : (
                      description
                    )}
                  </ShowMore>
                </CompetitionDescriptionWrapper>
              </FlexBox>
            </BottomGroupWrapper>
          </>
          {<FlexBox offsetTop={24} direction='column' directionMobile='column' justify='space-between'>
            <FlexBox 
              width={'100%'} 
              align="center" 
              direction='row' 
              directionMobile='row' 
              justify='space-between'
              justifyMobile={hasTabsItems ? 'space-between' : 'flex-end'} style={{ position: 'relative' }}>
              {!isGreenAward && !isExams ?  (
                !isMobile ? (
                  <SlideNavigation
                    activeIndexKey={activeTab}
                    onChange={onTabChange}
                    items={navItems}
                    isDropdown
                    autoWidth
                    isLoading={isLoading}
                    whiteTheme={false}
                    isCompetition={true}
                  />
                ) : (
                  MobileDropdownTabs
                )
              ) : null}

              <SelectWrapper
                direction="row"
                width={'100%'}
                widthMobile={'auto'}
                gx={5}
                justify={'flex-end'}
                justifyMobile={"flex-end"}
                directionMobile="row"
                align='flex-end'
                alignMobile='center'
                themeType={isGeograffee ? 'grey' : isCGRave ? 'black' : 'white'}
                isGeograffee={isGeograffee}
              >
                {
                  !isGreenAward &&
                  (
                    <CompetitionDropdown
                      selectedSorting={currentSorting}
                      onSortingChange={onChangeStatus}
                      sortingMethods={statusesOptions}
                      isDarkTheme={isDarkTheme}
                    />
                  )
                }
              </SelectWrapper>
            </FlexBox>
          </FlexBox>}
          {tagFilter && !isGreenAward && (
            <CompetitionTagsCloud filter={tagFilter} />
          )}
          {isLoading && currentTab !== COMPETITION_VIEW_TABS.winners && (
            <CompetitionContainer>
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
              <Skeleton width="100%" height={isMobile ? '208px' : '380px'} />
            </CompetitionContainer>
          )}
          {content}
        </CoreContainer>
      </CustomBgWrapper>
    </ThemeProvider>
  );
};
